export const NPS_EXPORT_REQUESTED = 'NPS_EXPORT_REQUESTED';

export const requestNpsExport = ({ email, startDate, endDate, useV2 }) => ({
  type: NPS_EXPORT_REQUESTED,
  payload: { email, startDate, endDate, useV2 },
});
